import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'components/Card';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { ActionDiv, Activity, Category, Date, Description, ImageContent, Info, InfoContent, Title } from './styles';

export interface ICardProps {
  category?: string;
  date?: string;
  description: string;
  image: string;
  title: string;
  link?: string;
  action?: JSX.Element;
}

const OptionalLink = (props: { children: JSX.Element; link?: string }): JSX.Element => {
  const { link, children } = props;
  return link ? <Link to={link}>{children}</Link> : children;
};

const ActivityCard = (props: ICardProps): JSX.Element => {
  const { category, date, description, image, title, link, action } = props;
  const { cleanUrl, crop } = parseCropHash(image);
  const { containerStyle, imageStyle } = getFramedImageStyles(crop);

  return (
    <Card>
      <Activity className="activity-card">
        <OptionalLink link={link}>
          <ImageContent className="activity-card-image-content" style={{ position: 'relative', overflow: 'hidden' }}>
            <div
              style={{
                position: 'absolute',
                top: '-10%',
                left: '-10%',
                width: '120%',
                height: '120%',
                background: `url(${cleanUrl}) center center / cover no-repeat`,
                filter: 'blur(15px)',
                zIndex: 1,
              }}
            />
            <div style={containerStyle}>
              <img src={cleanUrl} alt={title} style={imageStyle} />
            </div>
          </ImageContent>
        </OptionalLink>
        <InfoContent>
          {category && (
            <Info>
              <Category>{category}</Category>
              {action && <ActionDiv>{action}</ActionDiv>}
            </Info>
          )}
          {date && (
            <Info>
              <Date>{date}</Date>
            </Info>
          )}
          <Info>
            <Title>{title}</Title>
          </Info>
          <Info>
            <Description>{description}</Description>
          </Info>
        </InfoContent>
      </Activity>
    </Card>
  );
};

export default ActivityCard;
